export const TIMEOUT = 10000;
export const CLOSE_BUTTON_LABEL = 'Dismiss notification';
export const CLOSE_ICON_COLOR = 'interactive-black';
export const WARNING_ICON_COLOR = 'system-caution-yellow';
